import { createSlice } from "@reduxjs/toolkit";
import {
  getStorageItem,
  removeLocalStorageItems,
  setStorageItem,
} from "../../../utils/common-utils";

const deliveryTypeKey = "deliveryType";
const deliveryAddressKey = "deliveryAddress";
const orderInfoKey = "orderInfo";

const orderSlice = createSlice({
  name: "OrderInformation",
  initialState: {
    carts: getStorageItem("carts") || {},
    deliveryType: getStorageItem(deliveryTypeKey) || "",
    deliveryAddress: getStorageItem(deliveryAddressKey) || "",
    orderInformation: getStorageItem(orderInfoKey) || "",
  },
  reducers: {
    setCartDetails(state, action) {
      if (action.payload) {
        setStorageItem("carts", action.payload);
      } else {
        removeLocalStorageItems("carts");
      }

      state.carts = action.payload;
    },

    setDeliveryTypeDetails(state, action) {
      if (action.payload) {
        setStorageItem(deliveryTypeKey, action.payload);
      } else {
        removeLocalStorageItems(deliveryTypeKey);
      }

      state.deliveryType = action.payload || "";
    },

    setDeliveryAddressDetails(state, action) {
      if (action.payload) {
        setStorageItem(deliveryAddressKey, action.payload);
      } else {
        removeLocalStorageItems(deliveryAddressKey);
      }

      state.deliveryAddress = action.payload || "";
    },

    setOrderDetails(state, action) {
      if (action.payload) {
        setStorageItem(orderInfoKey, action.payload);
      } else {
        removeLocalStorageItems(orderInfoKey);
      }

      state.orderInformation = action.payload || "";
    },
  },
});

export const orderSliceActions = orderSlice.actions;

export default orderSlice.reducer;
